// extracted by mini-css-extract-plugin
module.exports = {"BottomTips":"Terms_BottomTips__68h8v"};